import { ReactComponent as IconSvg } from './icon_information.svg';
import Icon, { IconProps } from './icon';

const IconInformation = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconInformation;
